<template>
    <PlanbordGridCell
        v-for="(value, index) in timeTypes"
        :key="index"
        class="hour-balance"
        header
        balance
        centeredVertically
        v-show="isTimeTypeEnabled(value.id)"
    >
        {{ value.caption }}
    </PlanbordGridCell>

    <PlanbordGridCell
        v-for="(value, index) in leaveOverviews"
        :key="index"
        class="hour-balance"
        header
        balance
        centeredVertically
        v-show="isOverviewEnabled(value.id!)"
    >
        {{ value.name }}
    </PlanbordGridCell>

    <PlanbordGridCell
        v-for="(value, index) in deploymentCountConfigurations"
        :key="index"
        class="hour-balance"
        header
        balance
        centeredVertically
        v-show="isCountEnabled(value.id!)"
    >
        {{ value.name }}
    </PlanbordGridCell>
</template>

<script lang="ts">
    import {Component, Vue, Prop} from 'vue-facing-decorator';
    import {BalanceFilterType} from '@/components/FilterBar/types';
    import {TimeType, DeploymentCountConfiguration, LeaveOverview} from '@cquential/api';
    import PlanbordGridCell from '@/components/Planbord/PlanbordGridCell.vue';

    @Component({
        components: {
            PlanbordGridCell,
        },
    })
    export default class BalanceHead extends Vue {
        @Prop({required: true}) public timeTypes!: Record<number, TimeType>;
        @Prop({required: true}) public deploymentCountConfigurations!: DeploymentCountConfiguration[];
        @Prop({required: true}) public enabledBalanceAndCountDisplays!: Record<BalanceFilterType, Record<number, boolean>>;
        @Prop({required: true}) public leaveOverviews!: LeaveOverview[];

        public isTimeTypeEnabled(id: number): boolean {
            return this.enabledBalanceAndCountDisplays[BalanceFilterType.HourBalance][id] ?? false;
        }

        public isOverviewEnabled(id: number): boolean {
            return this.enabledBalanceAndCountDisplays[BalanceFilterType.LeaveOverview][id] ?? false;
        }

        public isCountEnabled(id: number): boolean {
            return this.enabledBalanceAndCountDisplays[BalanceFilterType.DeploymentCount][id] ?? false;
        }
    }
</script>

<style lang="scss" scoped>
    .tbody-td {
        color: #000;
        font-weight: 500;
    }

    .tfoot-td {
        color: #000;
        font-weight: bold;
        padding: .4rem .3rem;
    }
</style>
